import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TEMPLATE_TYPE } from 'src/app/constants';
import { ListQueryResult, Template } from 'src/models';
import { ApiService } from 'src/services/api.service';
import { AuthService } from 'src/services/auth.service';
import { MessageService } from 'src/services/message.service';

@Component({
  selector: 'app-templates-list',
  templateUrl: './templates-list.component.html',
  styleUrls: ['./templates-list.component.scss'],
})
export class TemplatesListComponent implements OnInit {
  @Input() communityId: string | null = null;

  myTemplates: Template[];
  sampleTemplates: Template[];
  isLoading = false;

  constructor(
    private msgSrvc: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    this.getList();
  }

  async getList() {
    const params = this.authService.isTenantAdmin
      ? this.authService.selectedProject
        ? {
            projectId: this.authService.selectedProject.id,
          }
        : {}
      : {
          projectId: this.authService.projects
            .filter(
              (p) =>
                this.authService.isProjectOwner(p.id) &&
                (!this.authService.selectedProject || p.id === this.authService.selectedProject.id),
            )
            .map((p) => p.id),
        };

    try {
      const result: any =
        !this.authService.selectedProject || this.authService.isProjectOwner(this.authService.selectedProject.id)
          ? await this.apiService.getPromise(`/templates`, params)
          : {
              rows: [],
            };

      this.myTemplates = result.rows;
    } catch (err) {
      this.msgSrvc.showError(err);
    } finally {
      this.isLoading = false;
    }

    const samples: ListQueryResult = await this.apiService.getPromise(`/template-samples`);
    this.sampleTemplates = samples.rows;
  }

  selectTemplate(template: Template) {
    if (template.tenantId) {
      // Existing template - navigate to edit
      this.router.navigate(['edit', template.id], { relativeTo: this.route });
    } else {
      // Sample template - navigate to copy
      this.router.navigate(['sample', template.id], { relativeTo: this.route });
    }
  }

  newEmailTemplate() {
    this.router.navigate(['new'], {
      relativeTo: this.route,
      queryParams: { type: TEMPLATE_TYPE.EMAIL },
    });
  }

  newSlackTemplate() {
    this.router.navigate(['new'], {
      relativeTo: this.route,
      queryParams: { type: TEMPLATE_TYPE.SLACK },
    });
  }

  getProjectName(projectId: string) {
    return this.authService.projects.find((p) => p.id === projectId)?.name;
  }
}
